import React, { useRef } from "react";
import styled from "styled-components";
import CountUp from "react-countup";
import { motion, useInView } from "framer-motion";

/* SECTION */
const Section = styled.section`
  width: 100%;
  padding: 80px 16px;
background: radial-gradient(circle at top, #fff5ee, #f7f2ff);
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 120px 60px;
  }
`;

/* WRAPPER */
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

/* TITLE */
const SectionLabel = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    font-size: 42px;
  }
`;

/* CONTENT GRID */
const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  text-align: left;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 80px;
  }
`;
const StatNumber = styled.div`
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 8px;

  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

/* BLOCK */
const ContentBlock = styled.div``;

const BlockTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;

  @media (min-width: 768px) {
    font-size: 26px;
  }
`;

const BlockText = styled.p`
  font-size: 15px;
  color: #555;
  line-height: 1.75;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

/* STATS */
const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  margin-top: 80px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 100px;
  }
`;

const StatCard = styled(motion.div)`
  text-align: center;
`;

const StatValue = styled.div`
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 6px;
`;

const StatLabel = styled.div`
  font-size: 14px;
  color: #777;
`;

/* SINGLE STAT COMPONENT */
const AnimatedStat = ({ value, suffix = "", label, delay }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.5 });

  const isNumber = typeof value === "number";

  return (
    <StatCard
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay }}
    >
      <StatNumber>
        {isInView && (isNumber ? <CountUp end={value} duration={2} /> : value)}
        {isNumber && suffix}
      </StatNumber>
      <StatLabel>{label}</StatLabel>
    </StatCard>
  );
};

/* MAIN COMPONENT */
const About = () => {
  return (
    <Section id="about-us">
      <Container>
        <SectionLabel>About Us</SectionLabel>

        <ContentGrid>
          <ContentBlock>
            <BlockTitle>Who We Are</BlockTitle>
            <BlockText>
              At <strong>Pragan Tech Solutions</strong>, we are passionate about
              empowering businesses through innovative IT solutions. From
              startups to growing companies, we provide reliable, scalable, and
              cost-effective IT services tailored to your needs.
            </BlockText>
          </ContentBlock>

          <ContentBlock>
            <BlockTitle>Our Mission</BlockTitle>
            <BlockText>
              Our mission is to help clients thrive in the digital era, turning
              ideas into reality with efficiency, creativity, and dedication. We
              deliver solutions that grow with your business and adapt to future
              challenges.
            </BlockText>
          </ContentBlock>
        </ContentGrid>

        <StatsRow>
          <AnimatedStat value={12} suffix="+" label="Clients Served" delay={0} />
          <AnimatedStat value={25} suffix="+" label="Projects Completed" delay={0.1} />
          <AnimatedStat value={"4.8/5"} label="Customer Satisfaction" delay={0.2} />
          <AnimatedStat value={3} suffix="+" label="Years in Business" delay={0.3} />
        </StatsRow>

      </Container>
    </Section>
  );
};

export default About;
